import { createApp } from 'vue';
import AOS from 'aos';
import 'aos/dist/aos.css';
import VueMobileDetection from 'vue-mobile-detection';
import App from './App.vue';
import router from './router';

createApp(App).use(router).use(VueMobileDetection).mount('#app');
AOS.init({ delay: 200, duration: 2000, once: true });
router.afterEach(() => requestAnimationFrame(() => AOS.refresh()));
